module.exports = __webpack_public_path__ + "img/place-des-arts.c813db53.webp";